import classNames from 'classnames';
import { useCallback, useMemo } from 'react';
import { Button, Heading, Step, StepProps, useStepByStep } from 'yoso';
import { BaseCard } from '~/components/Card';
import { T } from '~/components/I18n/Translation';
import lup from '~/components/Icon/lup.png';
import { useZone } from '~/components/Land/Zone/LandZone.hooks';
import { DescriptionList } from '~/components/List/Description/DescriptionList';
import { Lup } from '~/components/Lup/Lup';
import { Stepper } from '~/components/Stepper/Stepper';
import stepStyles from '../Step/ParticipationStep.module.scss';
import feeStyles from './ParticipationFee.module.scss';

export type ParticipationFeeStepProps = Omit<StepProps, 'name'> & {
  className?: string;
  landId: number;
  zoneId: number;
};

export const ParticipationFeeStep = ({
  className,
  landId,
  zoneId,
  ...props
}: ParticipationFeeStepProps) => {
  const { steps, forward } = useStepByStep();
  const stepIdx = useMemo(() => steps.indexOf('FEE'), [steps]);
  const onClick = useCallback(() => forward(), [forward]);

  const {
    data: {
      participationCriteria: { levelUpPassCount },
    },
  } = useZone({ landId, zoneId });

  return (
    <Step name="FEE" {...props}>
      <div className={classNames(stepStyles.root, className)}>
        <div className={stepStyles.header}>
          <Stepper className={stepStyles.stepper} activeStep={stepIdx} length={steps.length} />
        </div>
        <div className={stepStyles.body}>
          <img className={stepStyles.image} alt="step1" src={lup} width={100} height={100} />
          <Heading className={stepStyles.title} level={5}>
            <T name="citizen_land_join_sec1_title" />
          </Heading>
          <p className={stepStyles.description}>
            <T name="citizen_land_join_sec1_desc" balance />
          </p>
          <BaseCard className={feeStyles.root}>
            <DescriptionList className={feeStyles.descriptionList} layout="horizontal">
              <dt>
                <T name="citizen_land_join_fee" />
              </dt>
              <dd>
                <Lup value={levelUpPassCount} />
              </dd>
            </DescriptionList>
          </BaseCard>
        </div>
        <div className={stepStyles.footer}>
          <Button
            className={stepStyles.button}
            color="primary"
            onClick={onClick}
            data-event="click"
            data-event-target="land_popup_step1_cta_btn">
            <T name="citizen_button_title_fee_checked" />
          </Button>
        </div>
      </div>
    </Step>
  );
};
